export type DrawGeometryType = 'Polygon' | 'Circle' | 'Point' | 'LineString';

export function isDrawGeometryType(type: string): type is DrawGeometryType {
  return (
    type === 'Polygon' ||
    type === 'Circle' ||
    type === 'Point' ||
    type === 'LineString'
  );
}
